import { ThemeName } from 'modules/TradingChart/components/TradingView/sources/charting_library.min';

export enum SettingsType {
  SAVING_CHART_LAYOUT = 'SAVING_CHART_LAYOUT',
  SAVING_RECENT_LAYOUT = 'SAVING_RECENT_LAYOUT',
  SAVING_STUDY_TEMPLATES = 'SAVING_STUDY_TEMPLATES',
  SAVING_DRAWINGS = 'SAVING_DRAWINGS'
}

export type ChartLayoutResponse = {
  id?: string;
  profileId?: string;
  name: string;
  symbol: string;
  content?: string;
  resolution: string;
  timestamp?: string;
  theme?: ThemeName;
};

export type ChartTemplateResponse = {
  id?: string;
  profileId?: string;
  name: string;
  content?: string;
  timestamp?: string;
};

export type ChartRecentLayoutResponse = {
  id?: string;
  profileId?: string;
  content: string;
  timestamp?: string;
};

export type ChartSettingsResponse = ChartLayoutResponse
  | ChartTemplateResponse
  | ChartRecentLayoutResponse;

export type SavedChartLayoutListResponse = {
  savedLayouts: ChartLayoutResponse[];
};

export type SavedStudyTemplatesListResponse = {
  savedStudyTemplates: ChartTemplateResponse[];
};

export type ChartSettingsListResponse =
  | SavedChartLayoutListResponse
  | SavedStudyTemplatesListResponse;

export type SaveChartSettingsResponse = {
  id: string;
};

export type ChartSettingsRequest = {
  id?: string;
  name?: string;
  settingsType: SettingsType;
  loadingKey?: LoadingKey
};

export type SaveChartSettingsRequest = {
  id?: string;
  settingsType: SettingsType;
  data: ChartSettingsResponse;
  loadingKey?: LoadingKey;
};
